import { render, staticRenderFns } from "./MoneyCard.vue?vue&type=template&id=ab5ca898"
import script from "./MoneyCard.vue?vue&type=script&lang=js"
export * from "./MoneyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports